import Vue from "vue";
import Router from "vue-router";
import Task from "./views/task/Task.vue";
import TaskDetail from "./views/task/Detail.vue";
import Download from "./views/download/Download.vue";

import ClassList from "./views/class/index.vue";
import ClassDetail from "./views/class/detail.vue";
import PaperList from "./views/paper/index.vue";
import PaperUse from "./views/paper/use.vue";

import PaperCreate from "./views/paper/create.vue";
import CaseList from "./views/case/index.vue";

import LoginPage from "./views/LoginPage.vue";
import RegisterPage from "./views/RegisterPage.vue";
import Profile from "./views/user/Profile.vue";
import ProfileEdit from "./views/user/ProfileEdit.vue";
import PwdChange from "./views/user/Pwdchange.vue";
// competition
import CompetitionList from "./views/competition/List.vue";

import MainNavbar from "./layout/MainNavbar.vue";
import LoginNav from "./layout/LoginNav.vue";

import MainFooter from "./layout/MainFooter.vue";
import NotFound from "./views/NotFound.vue";
import PwdReset from "./views/user/PwdReset.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/home",
      name: "home",
      components: {
        default: CompetitionList,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/",
      name: "index",
      redirect: "/login",
      components: {
        default: CompetitionList,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/task",
      name: "Task",
      components: { default: Task, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/task/detail/:id",
      name: "TaskDetail",
      components: {
        default: TaskDetail,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/class",
      name: "class",
      components: {
        default: ClassList,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/class/detail/:id",
      name: "classDetail",
      components: {
        default: ClassDetail,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/paper",
      name: "paper",
      components: {
        default: PaperList,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/paper/use",
      name: "paperUse",
      components: {
        default: PaperUse,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/paper/create",
      name: "paperCreate",
      components: {
        default: PaperCreate,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/case",
      name: "case",
      components: {
        default: CaseList,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: "black" },
      },
    },
    // competition
    {
      path: "/competition/list",
      name: "CompetitionList",
      components: {
        default: CompetitionList,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/competition/detail/:id",
      name: "CompetitionDetail",
      components: {
        default: TaskDetail,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/profile",
      name: "profile",
      components: { default: Profile, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/profile/edit",
      name: "profileEdit",
      components: {
        default: ProfileEdit,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/profile/pwdChange",
      name: "pwdChange",
      components: {
        default: PwdChange,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 0 },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/password/reset/:captcha",
      name: "resetChange",
      components: {
        default: PwdReset,
        header: LoginNav,
        footer: null,
      },
      props: {
        header: { colorOnScroll: 0 },
      },
    },
    {
      path: "/login",
      name: "loginPage",
      components: { default: LoginPage, header: LoginNav, footer: null },
      props: {
        header: { colorOnScroll: 0 },
      },
    },
    {
      path: "/register",
      name: "registerPage",
      components: { default: RegisterPage, header: LoginNav, footer: null },
      props: {
        header: { colorOnScroll: 0 },
      },
    },
    {
      path: "/download",
      name: "Download",
      components: { default: Download, header: MainNavbar, footer: null },
      props: {
        header: { colorOnScroll: 0 },
      },
    },
    {
      path: "/:catchAll(.*)",
      name: "not-found",
      component: NotFound,
    },
  ],
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});
